import { render, staticRenderFns } from "./View15.vue?vue&type=template&id=5258764f"
import script from "./View15.vue?vue&type=script&lang=js"
export * from "./View15.vue?vue&type=script&lang=js"
import style0 from "./View15.vue?vue&type=style&index=0&id=5258764f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports